import { createSlice, current } from '@reduxjs/toolkit';
import {
	getWaterRightPositionList,
	getWaterRightPosition,
	addNewWaterRightPosition,
	updateWaterRightPosition,
	deleteWaterRightPosition,
	checkWaterRightPositionExists,
} from './thunk';

export const initialState = {
	itemWaterRightPositionList: [],
	itemWaterRightPosition: null,
	isWaterRightPositionLoading: false,
	isWaterRightPositionSuccess: false,
	dataWaterRightPosition: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const WaterRightPositionSlice = createSlice({
	name: 'WaterRightPosition',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getWaterRightPositionList.pending, state => {
			state.isLoadingList = true;
			state.isWaterRightPositionSuccess = false;
		});

		builder.addCase(getWaterRightPositionList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemWaterRightPositionList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isWaterRightPositionSuccess = true;
		});

		builder.addCase(getWaterRightPositionList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isWaterRightPositionSuccess = false;
		});

		builder.addCase(getWaterRightPosition.pending, state => {
			state.isWaterRightPositionLoading = true;
			state.isWaterRightPositionSuccess = false;
		});

		builder.addCase(getWaterRightPosition.fulfilled, (state, action) => {
			state.itemWaterRightPosition = action.payload;
			state.isWaterRightPositionLoading = false;
			state.isWaterRightPositionSuccess = true;
		});

		builder.addCase(getWaterRightPosition.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isWaterRightPositionLoading = false;
			state.isWaterRightPositionSuccess = false;
		});

		builder.addCase(addNewWaterRightPosition.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewWaterRightPosition.fulfilled, (state, action) => {
			state.itemWaterRightPositionList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewWaterRightPosition.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateWaterRightPosition.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateWaterRightPosition.fulfilled, (state, action) => {
			state.itemWaterRightPositionList = state.itemWaterRightPositionList.map(
				item =>
					item._id.toString() === action.payload._id.toString()
						? { ...item, ...action.payload }
						: item
			);
			state.statementList = state.statementList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateWaterRightPosition.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWaterRightPosition.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteWaterRightPosition.fulfilled, (state, action) => {
			state.itemWaterRightPositionList = current(
				state.itemWaterRightPositionList
			).filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteWaterRightPosition.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkWaterRightPositionExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkWaterRightPositionExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkWaterRightPositionExists.rejected, state => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = WaterRightPositionSlice.actions;

export default WaterRightPositionSlice.reducer;
